import { useContext as useReactContext } from 'react';
import { Context } from '@/components/slider-type/context';

export default function useContext() {
  const context = useReactContext(Context);
  if (!context) throw new Error('useContext must be used within a context');
  return context;
}
